import React from 'react';
import './CustomLoader.css';

interface CustomLoaderProps {
  size?: number;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({ size = 25 }) => {
  return (
    <div
      className="custom-loader"
      style={{ fontSize: `${size}px`, width: '1em', height: '1em' }}
    />
  );
};

export default CustomLoader;
